import { useEscalationContext } from '../context/escalation-context/EscalationContext';
import { getEscalationInfo } from '../services/EscalationService';
import { useNavigate } from 'react-router';
import { getEscalationNavigation } from '../utils/navigation/escalationNavigate';

export const operationV = [
    { url: '/update-personal-data', obd: true, otp: true },
    { url: '/select-bank-account', obd: true, otp: true },
    { url: '/profile/update-password', obd: true, otp: true },
    { url: '/configure-line/sim/feedbackSeeQRESIM', obd: true, otp: false },
    { url: '/configure-line/sim/installWithQr', obd: true, otp: false },
    { url: '/configure-line/sim/whereToInstall', obd: true, otp: false },
    { url: '/configure-line/multiSim/whereToInstall', obd: true, otp: false },
    { url: '/configure-line/sim/installInDevice', obd: true, otp: false },
    { url: '/configure-line/sim/copyCodeInstall', obd: true, otp: false },
    { url: '/configure-line/sim/feedbackInstallESIM', obd: true, otp: false },
    { url: '/configure-line/sim/duplicate', obd: true, otp: false },
    { url: '/configure-line/sim/duplicate/request', obd: true, otp: false },
    { url: '/change-ownership/customer-accounts', obd: true, otp: false },
];

export const useEscalation = () => {
    const navigate = useNavigate();
    const { setEscalationType, setContactsEscalation } = useEscalationContext();

    const fetchEscalationInfo = async () => {
        try {
            const response = await getEscalationInfo();
            setEscalationType(response.data.escalationType);
            setContactsEscalation(response.data.contacts);
            return {
                escalationType: response.data.escalationType,
                contacts: response.data.contacts,
            };
        } catch (error) {
            setEscalationType('NONE');
            setContactsEscalation([]);
            return {
                escalationType: 'NONE',
                contacts: [],
            };
        }
    };

    const handleEscalationFlow = async (url: string, flow: string, forceOBD?: boolean): Promise<void> => {
        if (forceOBD) {
            window.open(`${window.location.origin}/customer-verification?functionality=${flow}`, '_blank');
            return;
        }

        const { escalationType, contacts } = await fetchEscalationInfo();
        const { type } = getEscalationNavigation({
            escalationType,
            url,
            contacts,
        });

        if (type === 'navigate') {
            navigate(`${url}?flow=${flow}`);
        } else if (type === 'contacts') {
            navigate(`/escalation/contacts?contacts=${contacts}&flow=${flow}`);
        } else if (type === 'external') {
            window.open(`${window.location.origin}/customer-verification?functionality=${flow}`, '_blank');
        }
    };

    const escalationStorageListener = (url: string, extraData?: Record<string, any>) => {
        window.addEventListener('storage', (event) => {
            if (event.key === 'obd' && event.newValue) {
                try {
                    const data = JSON.parse(event.newValue);
                    if (data && data.type === 'obd') {
                        navigate(url, {
                            state: extraData,
                        });
                        localStorage.removeItem('obd');
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        });
    };

    return { fetchEscalationInfo, handleEscalationFlow, escalationStorageListener };
};
